import { Breadcrumb } from '@repo/ui/components/ui/breadcrumb';
import { Card } from '@repo/ui/components/ui/card';
import { GroupeForm } from '@repo/ui/features/groupe/groupe-form';
import { PageHeader } from '@repo/ui/ui/layout/page-header';
import { useNavigate } from 'react-router-dom';

export default function GroupeCreatePage() {
  const navigate = useNavigate();
  const goToList = () => navigate('/admin/droits/groupe');

  return (
    <div className="space-y-4">
      <div className="mb-2">
        <Breadcrumb
          items={[
            { label: 'Gestion' },
            { label: 'Groupes', href: '/admin/droits/groupe' },
            { label: 'Créer un groupe', current: true },
          ]}
          showHomeIcon
          onHomeClick={() => navigate('/admin/dashboard')}
          className="mb-4"
        />
      </div>

      <PageHeader>
        <PageHeader.Title>Créer un Groupe</PageHeader.Title>
      </PageHeader>

      <Card className="p-4">
        <GroupeForm onCancel={goToList} onSuccess={goToList} />
      </Card>
    </div>
  );
}
